import { z } from "zod/v4";

const permissionTypeSchema = z.enum(["tenant_role", "site_role", "camera_role"]);
const scopeTypeSchema = z.enum(["tenant", "site", "camera"]);

export const UserPermissionGrantedActivityMetadata = z.object({
  grantedByUserId: z.string().nullable(),
  grantedToUserId: z.string(),
  grantedToEmail: z.string().nullable(),
  permissionType: permissionTypeSchema,
  role: z.string().nullable(),
  cameraRole: z.string().nullable(),
  scopeType: scopeTypeSchema,
  scopeId: z.string(),
  source: z.enum(["create_role_assignment", "invite_user", "add_camera_permission", "hub_sync"]),
});
export type UserPermissionGrantedActivityMetadata = z.infer<typeof UserPermissionGrantedActivityMetadata>;

export const UserPermissionRevokedActivityMetadata = z.object({
  revokedByUserId: z.string().nullable(),
  revokedFromUserId: z.string(),
  permissionType: permissionTypeSchema,
  role: z.string().nullable(),
  cameraRole: z.string().nullable(),
  scopeType: scopeTypeSchema,
  scopeId: z.string(),
  source: z.enum(["remove_role_assignment", "revoke_camera_permission", "revoke_user_access"]),
  revokedRoles: z.array(z.string()).optional(),
  revokedCameraPolicies: z.array(z.string()).optional(),
});
export type UserPermissionRevokedActivityMetadata = z.infer<typeof UserPermissionRevokedActivityMetadata>;
